import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/fur-handler/")({
  head: () => routeHead("/de/fur-handler/"),
  beforeLoad: () => {
    throw redirect({ href: "/dealeri", statusCode: 301, replace: true });
  },
});
